"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
const signUp_graphql_1 = tslib_1.__importDefault(require("../gql/users/mutations/signUp.graphql"));
const updateUser_graphql_1 = tslib_1.__importDefault(require("../gql/users/mutations/updateUser.graphql"));
const recoveryPassword_graphql_1 = tslib_1.__importDefault(require("../gql/users/mutations/recoveryPassword.graphql"));
const updatePassword_graphql_1 = tslib_1.__importDefault(require("../gql/users/mutations/updatePassword.graphql"));
class User extends BaseModel_1.default {
    constructor() {
        super(...arguments);
        this.updateMutation = updateUser_graphql_1.default;
    }
    defaults() {
        return {
            uuid: '',
            email: '',
            password: '',
            name: '',
            logo: '',
            firstName: '',
            lastName: '',
            middleName: '',
            organizations: [],
            currency: null,
            consolidateAmounts: false,
            payableRate: 0,
        };
    }
    fetchToken(mutation, queryVariables) {
        return this.mutate(mutation, queryVariables);
    }
    signUp() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(signUp_graphql_1.default, yield this.prepareVariables());
        });
    }
    recoveryPassword() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(recoveryPassword_graphql_1.default, yield this.prepareVariables());
        });
    }
    updatePassword() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(updatePassword_graphql_1.default, yield this.prepareVariables());
        });
    }
    prepareVariables() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const user = yield this.getUpdateVariables();
            return {
                user,
            };
        });
    }
}
exports.default = User;
//# sourceMappingURL=User.js.map